import { Flex } from "antd";
import { useCompanyDetails } from "../../../../modules/settings/settings.queries";

import CompanyContactSection from "./CompanyContactSection";
import style from "./CompanyDetails.module.scss";
import CompanyDetailsSection from "./CompanyDetailsSection";

export const CompanyDetails = () => {
  const { data } = useCompanyDetails();

  return (
    <Flex className={style.companyDetails} gap={10}>
      <CompanyDetailsSection companyDetails={data} />
      <CompanyContactSection companyDetails={data} />
    </Flex>
  );
};
